export default __webpack_public_path__ + "static/media/reg_rapine.69addd80.pdf";